<template>
    <div>
        图片组件{{row}}
    </div>
</template>


<script>
export default {
    props:['row'],
    data(){
        return{

        }
    }
}
</script>